import React, { useEffect, useState } from "react";
import { Link , useNavigate } from "react-router-dom";

const Header = () => {
  const [student, setStudent] = useState(null);
  const [isProfileDropDownOpen, setIsProfileDropDownOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const st = window.localStorage.getItem("student");
    
    if (st) setStudent(JSON.parse(st));
  }, []);

  const handleLogout = () => {
    // Handle logout logic here
    window.localStorage.removeItem("student");
    window.localStorage.removeItem("authToken");
    navigate("/login");
    setStudent(null);
    setIsProfileDropDownOpen(false);
    setShowLogoutConfirm(false);
  };

  return (
    <header className="bg-white text-red">
      <div className="container mx-auto px-4 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <img
            src="/DU_Logo.svg"
            alt="GameZone"
            className="w-28"
            data-popover-target="profile-menu"
          />
        </Link>
        <div className="flex gap-7 items-center justify-between">
          <div>
            <div
              className="flex gap-2 items-center cursor-pointer"
              onClick={() => {
                setIsProfileDropDownOpen(!isProfileDropDownOpen);
              }}
            >
              <div className="border border-red-500 font-bold text-red-500 rounded-full size-11 flex items-center justify-center">
                {student?.name?.[0].toUpperCase()}
              </div>
              <div className="hidden md:flex flex-col items-start">
                <span className="text-lg font-bold">{student?.name}</span>
                <span className="text-sm">{student?.enrollmentNumber}</span>
              </div>
            </div>
            {isProfileDropDownOpen && (
              <div
                className="absolute right-4 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="menu-button"
                tabIndex={-1}
              >
                <div className="py-1" role="none">
                  <Link
                    to="/contact-us"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                    role="menuitem"
                    tabIndex={-1}
                    id="menu-item-0"
                    onClick={() => {
                      setIsProfileDropDownOpen(false);
                    }}
                  >
                    Contact Us
                  </Link>

                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                    role="menuitem"
                    tabIndex={-1}
                    id="menu-item-0"
                    onClick={() => {
                      setIsProfileDropDownOpen(false);
                    }}
                  >
                    Profile
                  </Link>
                  <button
                    type="button"
                    className="group relative block w-full px-4 py-2 text-left text-sm font-semibold text-red-700 bg-white rounded-lg shadow-md transition-all duration-200 hover:bg-red-100 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                    role="menuitem"
                    tabIndex={-1}
                    id="menu-item-3"
                    onClick={() => {
                      setShowLogoutConfirm(true);
                      setIsProfileDropDownOpen(false);
                    }}
                  >
                    <span className="group-hover:line-through group-hover:text-red-600 transition-all duration-300">
                      Log out
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
          <div className="bg-gradient-to-b from-[#190003] to-red-500 rounded-lg p-6 w-full max-w-sm text-white shadow-xl">
            <h3 className="text-xl font-bold mb-4">Confirm Logout</h3>
            <p className="text-white/80 mb-6">
              Are you sure you want to log out of your account?
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="flex-1 bg-transparent border border-white/20 text-white py-2 px-4 rounded-md hover:bg-white/10 transition-colors duration-300"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 bg-white text-red-500 py-2 px-4 rounded-md hover:bg-red-50 transition-colors duration-300 font-medium"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;

